import React, { FC, useReducer, createContext, useContext } from 'react';
import { TableRow } from '@code/innovance-react-ui-kit';

export enum ACTIONS {
  SET_ACCOUNT,
  CLEAR,
}

interface AccountValues {
  accountNumber: string;
  currency: string;
  selectedAccount?: TableRow;
}
interface TransferHistoryState {
  accountValues?: AccountValues;
  accountPageNumber: number;
}
type Action = { type: ACTIONS; payload?: any };
const transferHistoryReducer = (
  state: TransferHistoryState,
  action: Action
): TransferHistoryState => {
  switch (action.type) {
    case ACTIONS.SET_ACCOUNT:
      return {
        ...state,
        ...action.payload,
      };
    case ACTIONS.CLEAR:
      return initialValues;
    default:
      return state;
  }
};

type TransferHistoryDispatch = (action: Action) => void;
const TransferHistoryStateContext = createContext<TransferHistoryState | undefined>(undefined);
const TransferHistoryDispatchContext = createContext<TransferHistoryDispatch | undefined>(
  undefined
);
const initialValues = {
  accountValues: undefined,
  accountPageNumber: 1,
};

const TransferHistoryProvider: FC = ({ children }) => {
  const [state, dispatch] = useReducer(transferHistoryReducer, initialValues);

  return (
    <TransferHistoryStateContext.Provider value={state}>
      <TransferHistoryDispatchContext.Provider value={dispatch}>
        {children}
      </TransferHistoryDispatchContext.Provider>
    </TransferHistoryStateContext.Provider>
  );
};

export const useAccountState = (): TransferHistoryState => {
  const context = useContext(TransferHistoryStateContext);
  if (context === undefined) {
    throw new Error('useAccountState must be used within a TransferHistoryProvider');
  }

  return context;
};
export const useAccountDispatch = (): ((payload: TransferHistoryState) => void) => {
  const dispatch = useContext(TransferHistoryDispatchContext);
  if (dispatch === undefined) {
    throw new Error('useCustomerSearchDispatch must be used within a TransferHistoryProvider');
  }

  return (payload: TransferHistoryState) => dispatch({ type: ACTIONS.SET_ACCOUNT, payload });
};
export const useClearDispatch = (): (() => void) => {
  const dispatch = useContext(TransferHistoryDispatchContext);
  if (dispatch === undefined) {
    throw new Error('useClearDispatch must be used within a TransferHistoryProvider');
  }

  return () => dispatch({ type: ACTIONS.CLEAR });
};
export default TransferHistoryProvider;
